import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ShiftTimePicker from '../ShiftTimePicker';
import { CreateAttendanceDepartment } from '../../../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import { CleanIcon } from '../../../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../../../components/buttons/ButtonIcon';
import {errorMsg} from '../../../../../../../Apis/functions';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param show - Boolean to determine if the "Add New Workshift" modal should be shown
 * @param onHide - Function to hide the modal when triggered
 * @param setModified - Function to set the created status flag after adding a new workshift
 */
const AddNewWorkshift = ({ show, onHide, setModified }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [startShiftAt, setStartShiftAt] = useState('');
    const [endShiftAt, setEndShiftAt] = useState('');
    const [range, setRange] = useState('');
    const [departmentsId, setDepartmentsId] = useState('');
    const [showErrors, setShowErrors] = useState(false);

    //handle create new workshift
    const handleCreate = () => {
        if (!departmentsId || !startShiftAt || !endShiftAt) {
            setShowErrors(true);
            return;
        }
        const body = {
            departmentId: departmentsId,
            startShiftAt: startShiftAt,
            endShiftAt: endShiftAt,
            range: Number(range),
        };
        dispatch(CreateAttendanceDepartment(body)).then(({payload: {data: { success, code }}}) => {
                if (success === true) {
                    setModified(true);
                    onHide();
                    toast.success(t('has_been_created_successfully'));
                } else errorMsg(code);
            },
        );
    };
    // Clear all form fields and reset role state
    const clearField = () => {
        setStartShiftAt('');
        setEndShiftAt('');
        setRange('');
        setDepartmentsId('');
    };

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            onConfirm={handleCreate}
            title='create'
            size='lg'
            buttonConfirm='confirm'
            cancelButton={true}
            confirmButton={true}
        >
            <div className='d-flex justify-content-end mb-3'>
                <ButtonIcon
                    className='btn-clean-secondary-600'
                    id='btn_cnr_clean'
                    Icon={CleanIcon}
                    iconProps='btn-icon-svg-12px icon-color-general-00'
                    title={'clear_instances'}
                    onClick={() => {
                        clearField();
                    }}
                />
            </div>
            <div className="row px-0">
                <ShiftTimePicker
                    startShiftAt={startShiftAt}
                    setStartShiftAt={setStartShiftAt}
                    endShiftAt={endShiftAt}
                    setEndShiftAt={setEndShiftAt}
                    range={range}
                    setRange={setRange}
                    selectedDepartment={departmentsId}
                    setSelectedDepartment={setDepartmentsId}
                    displayNone={departmentsId === null}
                    showErrors={showErrors}
                />
            </div>
        </CustomModal>
    );
};

export default AddNewWorkshift;
